import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

import RoundButton from '@components/RoundButton'

import { CategoryComparatorKey } from '@routes/ScoredTableRoute/components/ScoredTable/utils/categorySortKeyComparatorKeys'
import { sorterDisplayNames } from '@routes/ScoredTableRoute/components/ScoredTable/utils/categorySortKeyComparatorKeys'

interface SortButtonProps {
    isActivated: boolean
    onClick: () => void
    selectedSortKey: CategoryComparatorKey
}

const SortButton = ({
    isActivated = false,
    onClick,
    selectedSortKey,
}: SortButtonProps) => (
    <RoundButton
        data-testid="sortButton"
        isActivated={isActivated}
        onClick={onClick}
    >
        <Icon icon="sort" color={theme.indigo60} size={16} />
        <Row
            display={['none', 'flex']}
            space="space05"
            ml="space10"
            mr="space05"
        >
            <Text variant="80" weight="bold" color="light">
                Sort by:
            </Text>

            <Text variant="80" color="light">
                {sorterDisplayNames[selectedSortKey]}
            </Text>
        </Row>
    </RoundButton>
)

export default SortButton
